import { Wrench } from 'lucide-react'
import type { NavEntry } from '@/app/nav-registry'

/** Nav entries only — imported by the eager shell bundle; keep free of pages/api (H-10). */

export const maintenanceNav: NavEntry = {
  label: 'Work orders',
  icon: Wrench,
  path: '/maintenance',
  permission: 'maintenance:read',
  order: 18,
}
